import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QuestProvider } from '@/context/QuestContext';
import { Toaster } from '@/components/ui/sonner';

import Landing from '@/pages/Landing';
import PlayerSetup from '@/pages/PlayerSetup';
import QuizIntro from '@/pages/QuizIntro';
import Quiz from '@/pages/Quiz';
import Processing from '@/pages/Processing';
import Result from '@/pages/Result';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminLeadDetail from '@/pages/AdminLeadDetail';
import AdminCourses from '@/pages/AdminCourses';

import '@/App.css';

export default function App() {
  return (
    <QuestProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/setup" element={<PlayerSetup />} />
          <Route path="/intro" element={<QuizIntro />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/processing" element={<Processing />} />
          <Route path="/result" element={<Result />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/courses" element={<AdminCourses />} />
          <Route path="/admin/leads/:id" element={<AdminLeadDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </QuestProvider>
  );
}
